import i18n from "@/i18n";

const routes = {
  path: "/course",
  name: "Course",
  component: () =>
    import(/* webpackChunkName: "course" */ "@/views/course/Main"),
  children: [
    {
      path: "courselist",
      alias: "",
      name: "CourseList",
      component: () =>
        import(/* webpackChunkName: "course" */ "@/views/course/CourseList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.golfcourse.golfcourse_list"),
        step: [
          i18n.t("page.golfcourse.golfcourse"),
          /* i18n.t("page.golfcourse.golfcourse_list"), */
        ],
        menu_num: 3,
        location: "/course/courselist",
      },
    },
    {
      path: "courseview/:courseno",
      name: "CourseView",
      component: () =>
        import(/* webpackChunkName: "course" */ "@/views/course/CourseView"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.golfcourse.golfcourse_view"),
        step: [
          i18n.t("page.golfcourse.golfcourse"),
          /* i18n.t("page.golfcourse.golfcourse_view"), */
        ],
        menu_num: 3,
        location: "/course/courselist",
      },
    },
    {
      path: "coursewrite",
      name: "CourseWrite",
      component: () =>
        import(/* webpackChunkName: "course" */ "@/views/course/CourseWrite"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.golfcourse.golfcourse_write"),
        step: [
          i18n.t("page.golfcourse.golfcourse"),
          /* i18n.t("page.golfcourse.golfcourse_write"), */
        ],
        menu_num: 3,
        location: "/course/courselist",
      },
    },
    {
      path: "courseedit/:courseno",
      name: "CourseEdit",
      component: () =>
        import(/* webpackChunkName: "course" */ "@/views/course/CourseEdit"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.golfcourse.golfcourse_edit"),
        step: [
          i18n.t("page.golfcourse.golfcourse"),
          /* i18n.t("page.golfcourse.golfcourse_edit"), */
        ],
        menu_num: 3,
        location: "/course/courselist",
      },
    },
  ],
};

export default routes;
